import { RootState } from 'redhotpie-shared-lib/hooks/useRedux';
import Conversation from 'redhotpie-shared-lib/models/conversation';
export function sortConversationByMessageTime(conversations: Conversation[]) {
  return conversations
    .filter(x => x.message && x.message.id)
    .sort((a, b) => {
      return b.message.time - a.message.time;
    });
}

export function sortConversationByMessageTimeArray(conversations: Conversation[]) {
  return conversations
    .filter(x => (x.message && x.message.id) || x.isGroup)
    .sort((a, b) => {
      return (a.message && b.message && b.message.time - a.message.time) || 0;
    });
}

export const getCountUnreadGift = (state: RootState) => {
  const data = state.conversationsReducer.data;
  let unread = 0;
  data.forEach(itm => (unread += itm.hasUnreadGifts ? 1 : 0));

  return unread;
};

export const getIsConversationsError = (state: RootState) => state.conversationsReducer.isConversationsError;
export const getIsConversationsPinedError = (state: RootState) => state.conversationsReducer.isConversationsPinedError;
export const getIsGetOrCreateConversationError = (state: RootState) => state.conversationsReducer.isGetOrCreateConversationError;
export const getIsSetReadConversationError = (state: RootState) => state.conversationsReducer.isSetReadConversationError;

export const getIsConversationsLoading = (state: RootState) => state.conversationsReducer.isConversationsLoading;
export const getIsGetOrCreateConversationLoading = (state: RootState) => state.conversationsReducer.isGetOrCreateConversationLoading;
export const getIsSetReadConversationLoading = (state: RootState) => state.conversationsReducer.isSetReadConversationLoading;
export const getConversationDetailLoading = (state: RootState) => state.conversationsReducer.conversationDetailLoading;
export const getIsConversationsLoadingNew = (state: RootState) => state.conversationsReducer.isConversationsLoadingNew;

export const getIsAPIFullDataLoaded = (state: RootState) => state.conversationsReducer.isAPIFullDataLoaded;
export const getIsSelectingPeerVCard = (state: RootState) => state.conversationsReducer.isSelectingPeerVCard;

export const getUnreadMatchingConversations = (state: RootState) => state.conversationsReducer.unreadMatchingConversations;
export const getUnreadConversations = (state: RootState) => state.conversationsReducer.unreadConversations;
export const selectConversationInfo = (state: RootState) => state.conversationsReducer.selectedConversationInfo;
export const getSelectedPeerVcard = (state: RootState) => state.conversationsReducer.selectedPeerVcard;
export const getDataPreVCard = (state: RootState) => state.conversationsReducer.dataPreVCard;
export const getConversationData = (state: RootState) => state.conversationsReducer.data;
export const getSearchParams = (state: RootState) => state.conversationsReducer.search;
export const getKeyword = (state: RootState) => state.conversationsReducer.search.keyword;
export const getPrimaryIndex = (state: RootState) => state.conversationsReducer.search.primaryIndex;
export const getSecondaryIndex = (state: RootState) => state.conversationsReducer.search.secondaryIndex;

export const getIsStatementShown = (state: RootState) => state.conversationsReducer.isStatementShown;
export const getIsAutoOpenMessengerSetting = (state: RootState) => state.conversationsReducer.isAutoOpenMessengerSetting;

export const getIsRetry = (state: RootState) => state.conversationsReducer.isRetry;
export const getPageNumber = (state: RootState) => state.conversationsReducer.pageNumber;
export const getPinListLength = (state: RootState) => state.conversationsReducer.pinListLength;
export const getPinMatchCount = (state: RootState) => state.conversationsReducer.pinMatchCount;

export const getNumberPinned = (state: RootState) =>
  state.conversationsReducer.data.filter(conv => (conv.isGroup ? !conv.isDelete && conv.pinned : conv.pinned)).length;
export const selectIsShowChatModal = (state: RootState) => state.conversationsReducer.isShowChatModal;
export const selectIsCanSendSingleChat = (state: RootState) => state.conversationsReducer.selectedConversationInfo?.canSend;
export const selectIsSelectedGroup = (state: RootState) => state.conversationsReducer.selectedPeerVcard?.isGroup;
export const getMessengerUploading = (state: RootState) => state.conversationsReducer.uploading;
export const getIsMemberSearch = (state: RootState) => state.conversationsReducer.isMemberSearch;
export const selectLastSyncTime = (state: RootState) => state.conversationsReducer.lastSyncTime;
export const selectPrivateRoomJids = (state: RootState) => state.conversationsReducer.privateRoomJids;
export const selectRoomJidsBeingJoined = (state: RootState) => state.conversationsReducer.roomJidsBeingJoined;
export const selectRoomJidsJoinedSuccess = (state: RootState) => state.conversationsReducer.roomJidsJoinedSuccess;
export const selectRoomJidsJoinedError = (state: RootState) => state.conversationsReducer.roomJidsJoinedError;

export const selectRemovingConversationData = (state: RootState) => state.conversationsReducer.removingConversationData;
export const getLastUpdateConversationsDataTime = (state: RootState) => state.conversationsReducer.lastUpdateConversationsDataTime;

export const getAutoSelectFirstConversation = (state: RootState) => state.conversationsReducer.isAutoSelectFirstConversation;
export const getAutoCallMessageAuthor = (state: RootState) => state.conversationsReducer.isAutoCallMessageAuthor;
export const selectChatServerTime = (state: RootState) => state.conversationsReducer.chatServerTime;
export const getConversationFilters = (state: RootState) => state.conversationsReducer.filters;
export const getConversationDefaultFilters = (state: RootState) => state.conversationsReducer.defaultFilters;
export const getShowConRefineModal = (state: RootState) => state.conversationsReducer.isShowConRefineModal;
export const getLocationDefault = (state: RootState) => state.conversationsReducer.location;
export const getLocationState = (state: RootState) => state.conversationsReducer.locationState;
export const getCountrySelected = (state: RootState) => state.conversationsReducer.countrySelected;
export const getStateSelected = (state: RootState) => state.conversationsReducer.stateSelected;
export const getConversationLocation = (state: RootState) => state.conversationsReducer.conversationLocation;
export const getShowAlertFilter = (state: RootState) => state.conversationsReducer.showAlertFilter;
export const selectIsPendingSendMessage = (state: RootState) =>
  state.conversationsReducer.conversationDetailLoading || state.conversationsReducer.isConversationsLoadingNew;
